import type { PortableTextBlock } from "@portabletext/types";
import type { AudioPlayerCardActionLink } from "../../types/audio-player-card";

import { RichText } from "../RichText";
import { AudioPlayerCardMarqueeText } from "./AudioPlayerCardMarqueeText";
import { AudioPlayerCardPrimaryAction } from "./AudioPlayerCardPrimaryAction";
import { AudioPlayerCardSpotifyLink } from "./AudioPlayerCardSpotifyLink";

type AudioPlayerCardMetaProps = {
  description?: PortableTextBlock[] | string;
  episodeNumber?: number;
  primaryActionLink?: AudioPlayerCardActionLink;
  publishedLabel?: string;
  title: string;
  titleAs?: "h1" | "h2" | "h3" | "p";
};

const DESCRIPTION_CLASS_NAME =
  "line-clamp-2 font-jakarta font-medium text-base leading-6";

function AudioPlayerCardMeta({
  description,
  episodeNumber,
  primaryActionLink,
  publishedLabel,
  title,
  titleAs = "h2",
}: AudioPlayerCardMetaProps) {
  const Title = titleAs;
  const titleText = episodeNumber ? `${episodeNumber}. ${title}` : title;

  return (
    <div className="flex min-w-0 flex-col gap-1">
      <div className="flex items-start justify-between gap-4">
        <Title className="min-w-0 flex-1 font-bold font-jakarta text-md leading-6 lg:text-lg lg:leading-8">
          <AudioPlayerCardMarqueeText text={titleText} />
        </Title>

        {primaryActionLink?.icon === "spotify" ? (
          <AudioPlayerCardSpotifyLink link={primaryActionLink} />
        ) : null}
      </div>

      {typeof description === "string" ? (
        <p className={DESCRIPTION_CLASS_NAME}>{description}</p>
      ) : description ? (
        <RichText
          className={`${DESCRIPTION_CLASS_NAME} max-w-2xl [&_p]:m-0`}
          value={description}
        />
      ) : null}

      {publishedLabel ? (
        <p className="font-jakarta text-new-beginnings-tints-200 text-sm leading-6">
          {publishedLabel}
        </p>
      ) : null}

      {primaryActionLink ? (
        <div className="mt-1">
          <AudioPlayerCardPrimaryAction link={primaryActionLink} />
        </div>
      ) : null}
    </div>
  );
}

export { AudioPlayerCardMeta };
